'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background: inherit;\n  border-radius: inherit;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding: ', ';\n  text-align: ', ';\n'], ['\n  background: inherit;\n  border-radius: inherit;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding: ', ';\n  text-align: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UIPopoverFooter = (0, _styledComponents2.default)(function (props) {
  var __align = props.align,
      __flush = props.flush,
      rest = _objectWithoutProperties(props, ['align', 'flush']);

  return _react2.default.createElement('footer', rest);
}).attrs({ className: 'uiPopoverFooter private-popover__footer' }).withConfig({
  displayName: 'UIPopoverFooter'
})(_templateObject, function (_ref) {
  var flush = _ref.flush;
  return flush ? '0' : _sizes.POPOVER_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X;
}, function (_ref2) {
  var align = _ref2.align;
  return align;
});

UIPopoverFooter.propTypes = {
  align: _react.PropTypes.oneOf(['left', 'right']).isRequired,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  flush: _react.PropTypes.bool
};

UIPopoverFooter.defaultProps = {
  align: 'left'
};

UIPopoverFooter.displayName = 'UIPopoverFooter';

exports.default = UIPopoverFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/tooltip/UIPopoverFooter.js
// module id = 950
// module chunks = 2 3